import FJAppConstant from '../../constants/FJAppConstant';
import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    resultImageKey: 'ai/export/object-erasure/',
    originalImageKey: 'ai/input/object-erase/',
    historyListType: 12,
    appType: FJAppConstant.OBJECT_ERASER,
    currentMenuName: 'ai-object-eraser',
    freeLimitType: 'object-remove',
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/objectEraser/bg.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/objectEraser/bg.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/objectEraser/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/objectEraser/video.mp4?v=${FJVersionConfig.staticPathVersion}`,

    quickSelectionTipVideoUrl:
        environment === LOCAL
            ? `/public/img/objectEraser/quick_selection_tips.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/objectEraser/quick_selection_tips.mp4?v=${FJVersionConfig.staticPathVersion}`,
    quickSelectionTipImgUrl:
        environment === LOCAL
            ? `/public/img/objectEraser/quick_selection_tips.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/objectEraser/quick_selection_tips.png?v=${FJVersionConfig.staticPathVersion}`,
};
